import { FC } from "react";
import Header from "../header/header";
import { Outlet } from "react-router-dom";
import SideNavigation from "../sideNaviation/sideNavigation";
import "./baseLayout.css";
import { useUser } from "../../context/userProvider";

const BaseLayout: FC = () => {
  const { currentUser,fetched } = useUser();

  return (
    currentUser ?
    (
    <div className="main-container">
      <Header />
      <div className="content-container">
        <SideNavigation />
        <div className="view-container">
          <Outlet />
        </div>
      </div>
    </div>
    )
    :(
       fetched ? 
      <div className="auth-loading-container">
        <h1>Kitchen Wizard</h1>
        <p>The organisation is not created yet</p>
      </div>  :
      
      <div className="auth-loading-container">
        <h1>Kitchen Wizard</h1>
        <p>Loading user....</p>
      </div>
    )



    
  
  );
};

export default BaseLayout;
